export interface GetTaskContentResponse {
    content: string;
}

export interface GetTaskContentApi {
    getTaskContent(taskId: string, contentType: string): Promise<any>;
}

export const GetTaskContentApi = Symbol('GetTaskContentApi');
